export default __webpack_public_path__ + "static/media/person.931da516.svg";